import { oc } from '@orpc/contract';
import { listVehicleActivityInputSchema, listVehicleActivityOutputSchema } from '../schemas/vehicles.schemas.js';
/**
 * Newest first. The estimate's own history was **copied onto the vehicle at the purchase**, so the
 * dossier opens with the negotiation that produced it rather than with an empty log (plan §5.6).
 */
export const listVehicleActivityContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}/activity',
    tags: ['Vehicles'],
    summary: 'List a stock vehicle’s activity',
})
    .input(listVehicleActivityInputSchema)
    .output(listVehicleActivityOutputSchema);
//# sourceMappingURL=list-vehicle-activity.contract.js.map